import { render, staticRenderFns } from "./date-panel-label.vue?vue&type=template&id=6de0450a"
import script from "./date-panel-label.vue?vue&type=script&lang=js"
export * from "./date-panel-label.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports